import Carousell from "./Carousell"
import Hero from "./Hero"
import HomeBody from "./HomeBody"

const Home = () =>{
    return(
        <>
        <Hero/>
        <Carousell/>
        <HomeBody/>
        </>
    )
}
export default Home